import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import useUI from 'hooks/use-ui';
import useColors from 'hooks/use-colors';
import useTranslation from 'hooks/use-translation';

import DutchieWordmark from 'assets/dutchie-wordmark';
import { EmbeddedExternalLink, Link } from 'components/core';

const PoweredByDutchie = observer((props) => {
  const colors = useColors();
  const { t } = useTranslation();
  const { isEmbedded } = useUI();

  const LinkWrapper = isEmbedded ? EmbeddedExternalLink : Link;

  return (
    <LinkWrapper href='https://dutchie.com/'>
      <Container {...props}>
        <Text>{t('footer.poweredBy', 'Powered by')}</Text>
        <DutchieWordmark height='12px' fill={colors.primaryGreen} alt={t('footer.dutchie', 'dutchie')} />
      </Container>
    </LinkWrapper>
  );
});

export default PoweredByDutchie;

const Container = styled.div`
  width: 100%;
  height: 30px;
  border-top: ${({ theme }) => `1px solid ${theme.colors.blueGrey[80]}`};
  box-shadow: 0px -2.62px 2px rgba(0, 0, 0, 0.042);
  background-color: white;
  z-index: 10;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Text = styled.p`
  color: ${({ theme }) => theme.colors.grey[35]};
  font-size: 12px;
  line-height: 20px;
  margin-right: 5px;
`;
